import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {Strut} from "@khanacademy/wonder-blocks-layout";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {LabelSmall} from "@khanacademy/wonder-blocks-typography";

import sharedStyles from "./shared-styles.ts";

interface Props {
    message: string;
}

export const FormError = ({message}: Props): React.ReactElement => (
    <View>
        <Strut size={spacing.xxSmall_6} />
        <LabelSmall style={sharedStyles.redText}>{message}</LabelSmall>
    </View>
);
